<template>
    <div>
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            App Navbar:
        </div>
        <div class="relative">
            <RedesignAppNavbar
                key="base-navbar"
                class=""
                :edit-mode="editMode"
                layout-type="activeLayout"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import RedesignAppNavbar from '@/components/RedesignComponents/App/RedesignAppNavbar.vue'

const editMode = ref<boolean>(false)
</script>

<style lang="scss">

</style>
